export enum ChartTypeEnum {
  Table = 'table',
  Line = 'line',
  Bar = 'bar',
  Scatter = 'scatter',
  Pie = 'pie',
  Single = 'single',
  PivotTable = 'pivot_table'
}
